<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="tanggal mt-3 text-right monaco">
          <em v-if="waktu == ''" class="text-muted">memuat waktu</em>
          <span v-else>{{ waktu }} {{ tanggal }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tanggal: "",
      waktu: "",
    };
  },
  mounted() {
    setInterval(() => {
      this.getDate();
    }, 1000);
  },
  methods: {
    getDate() {
      let months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];
      let now = new Date();
      this.tanggal = now.getDate() + " " + months[now.getMonth()] + " " + now.getFullYear();
      this.waktu = now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds() + " / ";
    },
  },
};
</script>

<style scoped>
.tanggal {
  font-size: 12px;
}
</style>
